module.exports = __webpack_public_path__ + "img/income.92a4837e.svg";